<template>
    <div class="alter-detail">
        <h3 class="minor-title"><span class="danger-text">*</span> 预算调整明细</h3>
        <el-tabs @tab-remove="handleTabRemove" v-model="activeTabId" @tab-click="showTableTransitionCss">
            <!-- {{ tabList}} -->
                <!-- :label="alterType == '3' ? item.dicName + (index + 1) + '-' + item.dicId : item.dicName + (item.dicId)" -->
                <!-- :label="alterType == '3' ? item.dicName + (index + 1) : item.dicName" -->
            <el-tab-pane v-for="(item, index) in tabList" :name="item.dicId" :key="item.dicId"
                :label="alterType == '3' ? item.dicName + (index + 1) : item.dicName"
                :closable="alterType == '3' && tabList && tabList.length > 1">
            </el-tab-pane>
        </el-tabs>
        <!-- {{ submitParms.detailList}} -->
        <!-- 
        {{ submitParms.ext1 }} -->
        <transition name="fade-table">
            <div v-if="transition">
                <!-- TODO 是否添加预算大类 -->
                <div v-for="(item, index) in submitParms.detailList" :key="item[0].subjectsCatId + '_' + item[0].firstDeptId + index">
                    <alter-detail-table 
                        :dataIndex="index"
                        :tableDisabled="tableDisabled"
                        :ref="'alter-Table'"
                        :firstDeptList="firstDeptList"
                        :businessUnitList="businessUnitList"
                        v-if="
                            ((String(item[0].subjectsCatId) === String(activeTabId)) && String(submitParms.ext1) === '1') || 
                            ((String(item[0].firstDeptId) === String(activeTabId)) && String(submitParms.ext1) === '2') ||
                            ((String(item[0].tabId) === String(activeTabId)) && String(submitParms.ext1) === '3') ||
                            String(submitParms.ext1) === '5' || submitParms.detailList.length === 1"
                        :submitParms="submitParms"
                        :yearType="yearType"
                        :year="year"
                        :budgetTypeList="budgetTypeList"
                        :checkeDeptCodeList="checkeDeptCodeList"
                        :elasticityTabList="elasticityTabList"
                        :checkedBudgetTypeList="checkedBudgetTypeList"
                        :alterType="submitParms.ext1"
                        :detailList="submitParms.detailList[index]"
                        @setTitle="setTitle($event)"
                        @setDetailList="setDetailList($event, index)"
                    ></alter-detail-table>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import AlterDetailTable from "./AlterDetailTable.vue";
import {
    awaitWrapper,
    sleep
} from "@/common/utils/assist.js"; //
import { 
    getBusinessUnitList,
    // getEhrFirstDepts
} from "../request";

export default {
    components: {
        AlterDetailTable,
    },
    props: {
        firstDeptList: {
            default: ()=> [],
            type: Array
        },
        tableDisabled: {
            default: false,
            type: Boolean
        },
        pageLoading: {
            default: false,
            type: Boolean
        },
        yearType: null,
        year: null,
        alterType: null,
        // detailList: [], // 调整信息
        checkedBudgetTypeList: {
            default: () => [],
            type: Array
        }, // 预算大类

        submitParms: {
            default: () => { 
                detailList: []
            },
            type: Object
        },
        budgetTypeList: [], // 相同预算大类tab
        checkeDeptCodeList: [], // 相同一级部门tab
        elasticityTabList: [], // 弹性调整tab
    },
    watch: {
        checkedBudgetTypeList: { // 选中的预算大类
            handler: function (newval, oldval) {
                this.setTabList(newval, oldval)
                this.handleTableTransitionCss(newval, oldval) // 是否需要展示table 切换css
                this.setTableData(newval, oldval)
                /* V3.6.2 已下线：历史编辑 isEditByExtType3 分支
                if (this.$store.state.yearBudget.isEditByExtType3) {
                    this.$store.commit('SET_IS_EDIT_BY_EXT_TYPE3', false)
                } else {
                    this.setChildTypeByTabId()
                }
                */
                this.setChildTypeByTabId()
            },
            immediate: true,
            deep: true
        },
        checkeDeptCodeList: { // 选中的预算一级部门
            handler: function (newval, oldval) {
                this.setTabList(newval, oldval)
                this.handleTableTransitionCss(newval, oldval) // 是否需要展示table 切换css
                this.setTableData(newval, oldval)
            },
            immediate: true,
            deep: true
        },
        elasticityTabList: { // 弹性调整
            handler: function (newval, oldval) {
                this.setTabList(newval, oldval)
                this.handleTableTransitionCss(newval, oldval) // 是否需要展示table 切换css
                this.setTableData(newval, oldval)
                // this.setChildTypeByTabId()
            },
            immediate: true,
            deep: true
        },
        pageLoading: {
            handler: function(newval, oldval) {
                this.loading = newval
            },
            immediate: true,
        }
    },
    data() {
        return {
            loading: false,
            tabList: [], // 查询的tab切换
            activeTabId: null, // 当前选中的预算大类
            transition: true,
            // firstDeptList: [], // 一级部门
            businessUnitList: [], // 事业部
            // isInit: true
        };
    },
    created() {
        this.getBusinessUnitList()
    },
    methods: {
        handleTabRemove(targetName) { // 删除
            this.$emit('delTab', targetName)
        },
        async getBusinessUnitList() {
            this.loading = true
            let [, res] = await awaitWrapper(getBusinessUnitList())
            this.loading = false
            this.businessUnitList = (res.data || []).map(item => {
                return {
                    ...item,
                    dicId: item.id,
                    dicName: item.name,
                }
            })
        },
        // async getEhrFirstDepts() {
        //     this.loading = true
        //     let [, res] = await awaitWrapper(getEhrFirstDepts())
        //     this.loading = false
        //     this.firstDeptList = (res.data.nodes || []).map(item => {
        //         return {
        //             ...item,
        //             dicId: item.id,
        //             dicName: item.name,
        //             ehrFirstId: item.id
        //         }
        //     })
        //     this.firstDeptList = this.firstDeptList.filter((item) => {
        //         return String(item.mapid) !== "0";
        //     });
        // },
        handleTableTransitionCss(newval, oldval) {
            if (Array.isArray(newval) && newval.length > 0) {
                const hasActiveTabId = newval.find(item => String(item.dicId) === String(this.activeTabId))
                if (!hasActiveTabId) {
                    this.activeTabId = String(newval[0].dicId)
                    this.showTableTransitionCss()
                }
            } else {
                this.activeTabId = ""
                this.showTableTransitionCss()
            }
            
        },
        setTabList(newval, oldval) {
            // console.log('newval', newval)
            this.tabList = (newval || []).map(item => {
                return {
                    ...item,
                    dicId: String(item.dicId),
                }
            })
            // console.log('this.tabList', this.tabList)
        },
        setTitle(event) {
            this.$emit("setTitle", event)
        },
        setDetailList(event, index) {
            console.log('setDetailList 1', event)
            this.$emit("setDetailList", {
                detailList: event,
                index
            })
        },
        async showTableTransitionCss() {
            this.transition = false
            await sleep(100)
            this.transition = true
            this.setChildTypeByTabId()
        },
        setTableData(newTabList, oldTabList) {
            if (this.$store.state.yearBudget.isEditByExtType3 ||
                this.$store.state.yearBudget.isEditByExtType1 ||
                this.$store.state.yearBudget.isEditByExtType2 ||
                this.$store.state.yearBudget.isEditByExtType5
            ) {
                this.$store.commit('SET_IS_EDIT_BY_EXT_TYPE3', false)
                this.$store.commit('SET_IS_EDIT_BY_EXT_TYPE1', false)
                this.$store.commit('SET_IS_EDIT_BY_EXT_TYPE5', false)
                this.$store.commit('SET_IS_EDIT_BY_EXT_TYPE2', false)
                return
            }
            // 处理初始化空数据/没有选择预算大类的数据
            this.setTableDataByEmptyDetailList(newTabList, oldTabList)
            // if (this.setTableDataByEmptyDetailList(newTabList, oldTabList)) {
            //     return
            // }
            // 处理需要新增的情况
            this.setTableDataByAddDetailList(newTabList, oldTabList)
            // 处理需要过滤的情况
            // console.log('before setTableDataByFilterDetailList')
            this.setTableDataByFilterDetailList(newTabList, oldTabList)
        },
        isImportedDetailRow(row) {
            if (!row) {
                return false
            }
            return !!(row.subjectsTypeId || row.subjectsCatId || row.cycleMonth
                || row.adjustAmount || row.shareTypeNo)
        },
        hasImportedDetailInList() {
            const detailList = this.submitParms.detailList || []
            const self = this
            return detailList.some(function(group) {
                if (!Array.isArray(group)) {
                    return false
                }
                return group.some(function(row) {
                    return self.isImportedDetailRow(row)
                })
            })
        },
        hasImportedDetailRows(tabIds) {
            if (!Array.isArray(tabIds) || tabIds.length === 0) {
                return false
            }
            const detailList = this.submitParms.detailList || []
            const self = this
            return tabIds.some(function(tabId) {
                const group = detailList.find(function(item) {
                    return Array.isArray(item) && item[0]
                        && String(item[0].firstDeptId) === String(tabId)
                })
                if (!group) {
                    return false
                }
                return group.some(function(row) {
                    return self.isImportedDetailRow(row)
                })
            })
        },
        setTableDataByFilterDetailList(newTabList, oldTabList) {
            const newTabListId = newTabList.map(item=>{
                return String(item.dicId)
            })
            // console.log('newTabListId', newTabListId)
            // console.log('this.submitParms.detailList', this.submitParms.detailList)
            const newDetailList = this.submitParms.detailList.filter(item=>{
                /* V3.6.2 已下线 ext1=1
                if (String(this.submitParms.ext1) === '1') {
                    return newTabListId.includes(String(item[0].subjectsCatId))
                } else */
                if (String(this.submitParms.ext1) === '2') {
                    return newTabListId.includes(String(item[0].firstDeptId))
                /* V3.6.2 已下线 ext1=3
                } else if (String(this.submitParms.ext1) === '3') {
                    return newTabListId.includes(String(item[0].tabId))
                }
                */
                }
                return false
            })
            // console.log('setDetailList 2', newDetailList)
            this.$emit("setDetailList", {
                detailList: newDetailList || [{}],
                index: -1
            })
        },
        setTableDataByAddDetailList(newTabList, oldTabList) {
            /* V3.6.2 已下线：历史编辑/草稿跳过 tab 自动追加行
            if (this.$store.state.yearBudget.isEditByExtType3 ||
                this.$store.state.yearBudget.isEditByExtType1 ||
                this.$store.state.yearBudget.isEditByExtType2 ||
                this.$store.state.yearBudget.isEditByExtType5
            ) {
                this.$store.commit('SET_IS_EDIT_BY_EXT_TYPE3', false)
                this.$store.commit('SET_IS_EDIT_BY_EXT_TYPE1', false)
                this.$store.commit('SET_IS_EDIT_BY_EXT_TYPE5', false)
                this.$store.commit('SET_IS_EDIT_BY_EXT_TYPE2', false)
                return
            }
            */
            if(!this.activeTabId) {
                return
            }
            const oldTabIds = (oldTabList || []).map(item=>{
                return String(item.dicId)
            })
            const newTabIds = (newTabList || []).map(item=>{
                return String(item.dicId)
            })
            const needAddTabIds = newTabIds.filter(item=>{
                return !oldTabIds.includes(item)
            })
            if ((!oldTabIds || oldTabIds.length === 0) && this.hasImportedDetailRows(newTabIds)) {
                return
            }
            // console.log('newTabIds, oldTabIds', newTabIds, oldTabIds)
            // console.log('newTabList, oldTabList', needAddTabIds, newTabList, oldTabList)
            // console.log('needAddTabIds', needAddTabIds)
            for(let i = 0; Array.isArray(needAddTabIds) && i < needAddTabIds.length ; i++) {
                // const newDetailList = this.submitParms.ext1 == 5? [{subjectsCatId: parseInt(needAddTabIds[i])}]: [{subjectsCatId: parseInt(needAddTabIds[i])}, {subjectsCatId: parseInt(needAddTabIds[i])}]
                let newDetailList 
                /* V3.6.2 已下线 ext1=1
                if (String(this.submitParms.ext1) === '1') {
                    const subjectsCatName = this.tabList.find(item=>{
                        return String(item.dicId) === String(needAddTabIds[i])
                    }).dicName
                    newDetailList =[{subjectsCatId: parseInt(needAddTabIds[i]), subjectsCatName: subjectsCatName}, {subjectsCatId: parseInt(needAddTabIds[i]), subjectsCatName: subjectsCatName}]
                } else */
                if (String(this.submitParms.ext1) === '2') {
                    const checkFirstDeptName = this.firstDeptList.find(item=>{
                        return String(item.dicId) === String(needAddTabIds[i])
                    }).dicName
                    newDetailList =[{firstDeptId: parseInt(needAddTabIds[i]), firstDeptName: checkFirstDeptName}, {firstDeptId: parseInt(needAddTabIds[i]), firstDeptName: checkFirstDeptName}]
                }
                /* V3.6.2 已下线 ext1=3
                else if (String(this.submitParms.ext1) === '3') {
                    newDetailList = [{tabId: 1}]
                }
                */
                // console.log('index', !oldTabIds || oldTabIds.length === 0? 0 : this.submitParms.detailList.length)
                // console.log('newDetailList111111111', newDetailList)
                this.$emit("setDetailList", {
                    detailList: newDetailList || [{}],
                    index: !oldTabIds || oldTabIds.length === 0? 0 : this.submitParms.detailList.length
                })
                
            }
        },
        setTableDataByEmptyDetailList(newTabList, oldTabList) {
            if (!Array.isArray(newTabList) || newTabList.length == 0 ) {
                if (String(this.submitParms.ext1) === '2' && this.hasImportedDetailInList()) {
                    return false
                }
                let newDetailList;
                /* V3.6.2 已下线 ext1=1
                if (String(this.submitParms.ext1) === '1') {
                    const subjectsCatName = this.activeTabId
                    newDetailList = [{subjectsCatId: parseInt(this.activeTabId)}, {subjectsCatId: parseInt(this.activeTabId)}]
                } else */
                if (String(this.submitParms.ext1) === '2') {
                    newDetailList = [{firstDeptId: parseInt(this.activeTabId)}, {firstDeptId: parseInt(this.activeTabId)}]
                }
                /* V3.6.2 已下线 ext1=3 else if (String(this.submitParms.ext1) === '3') {
                    newDetailList = [{tabId: 1}]
                }
                */
                // const newDetailList = this.submitParms.ext1 == 5? [{subjectsCatId: parseInt(this.activeTabId)}]: [{subjectsCatId: parseInt(this.activeTabId)}, {subjectsCatId: parseInt(this.activeTabId)}]
                // console.log('setDetailList 4', newDetailList)
                this.$emit("setDetailList", {
                    detailList: newDetailList || [{}],
                    index: 0
                })
                return true
            }
            return false
        },
        async setChildTypeList(index, i) {
            await sleep(200)
            if (this.$refs['alter-Table'] && this.$refs['alter-Table'][index]) {
                this.$refs['alter-Table'][index].setChildTypeList(i, true)
            } else {
                this.setChildTypeList(index, i)
            }
        },
        async setChildTypeByTabId() {
            if (String(this.submitParms.ext1) !== '1') {
                return
            }
            if (!this.activeTabId) {
                return
            }
            const checkedDetailIndex = (this.submitParms.detailList || []).findIndex(item=>{
                return String(item[0].subjectsCatId) == String(this.activeTabId)
            })
            if (checkedDetailIndex < 0) {
                return
            }
            for (let i = 0; i < this.submitParms.detailList[checkedDetailIndex].length; i++) {
                this.setChildTypeList(checkedDetailIndex, i)
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.fade-table-enter-active,
.fade-table-leave-active {
    transition: all 0.4s ease; // 简化过渡效果
}

.fade-table-enter {
    opacity: 0;
    transform: translateX(-50px); // 只保留水平方向的移动
}

.fade-table-leave-to {
    opacity: 0;
    transform: translateX(50px); // 离开时向右移动
}
.alter-detail /deep/.el-tabs__item {
    color: #606266;
}
.alter-detail /deep/.el-tabs__item.is-active {
    color: #1890FF;
}
</style>